import { Subject, Subscription, switchMap } from 'rxjs';

import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';

import { CompetitorInfo } from 'src/app/models/competitor-info';
import { RaceRefreshObject } from 'src/app/models/race_refresh_object';
import { ProgressService } from 'src/app/services/progress.service';
import { ImageService } from '../../services/image.service';
import { Race } from 'src/app/models/race';
import { RaceClass } from 'src/app/models/race-class';
import { Registration } from 'src/app/models/registration';
import { CommonService } from 'src/app/services/common.service';
import { SettingsService } from 'src/app/services/settings.service';
import { MessageService } from 'primeng/api';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-progress',
  templateUrl: './progress.component.html',
  styleUrls: ['./progress.component.scss'],
})
export class ProgressComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  date: Date;
  day!: number;
  month!: number;
  year!: number;
  selectedRace: Race | undefined;
  raceClasses: RaceClass[] = [];
  selectedRaceTmp: Race | undefined;
  selectedClass: RaceClass | undefined = undefined;
  invalidDates!: Array<Date>;
  selectTable!: string;
  preSelectRace: string | null = null;
  preSelectClass = null;
  currentDate = new Date();

  TVResume = false;
  sections: number = 1;

  showCompetitorRaceInfoModal = false;
  dataCompetitorRaceInfoModal: string = '';

  showCompetitorInfoModal = false;
  dataCompetitorInfoModal: CompetitorInfo | null = null;
  private getInfoCompInitiator: Subject<Registration['user']['cUid']> = new Subject();
  subscriptionGet: Subscription | undefined = undefined;;
  timer: number = 1000;
  fullImageUrl: string | undefined;
  fullPdfUrl: string | undefined;

  constructor(
    public progressService: ProgressService,
    public messageService: MessageService,
    public authService: AuthService,
    private route: ActivatedRoute,
    public appSettings: SettingsService,
    private titleService: Title,
    private datePipe: DatePipe,
    private commonService: CommonService,
    private imageService: ImageService,
    private cdr: ChangeDetectorRef,
  ) {
    this.subscriptions.push(
      this.commonService.pdfFullScreenEvent.subscribe((fullPdfUrl) => {
        this.fullPdfUrl = fullPdfUrl;
      })
    );
    this.subscribeToGet();
    this.subscriptions.push(
      this.route.queryParams.subscribe((params) => {
        const section = params['section'];
        if (!section) {
          return;
        }

        this.appSettings.settings = this.appSettings.settings;

        if (section === 'results-table') {
          this.selectTable = this.appSettings.TABLE_TYPE.PROGRESS;
        } else if (section === 'results') {
          this.selectTable = this.appSettings.TABLE_TYPE.PROGRESSV2;
        } else if (section === 'documents') {
          this.selectTable = this.appSettings.TABLE_TYPE.DOCUMENTS;
        } else {
          this.selectTable = this.appSettings.TABLE_TYPE.PROGRESS;
        }


        this.timer = params['timer'] ? Number(params['timer']) : 5000;

        // Это настройки для автообновления старого прогресса для телевизора
        if (params['clUid'] && (!this.selectedClass || this.selectedClass.clUid !== params['clUid'])) {
          this.selectedClass = new RaceClass({ clUid: params['clUid'] });
          this.TVResume = true;
          setInterval(
            () => {
              this.progressService.refreshTableData.emit(this.selectedClass?.clUid);
            },
            this.timer
          );
        }

        if (params['sections']) {
          this.sections = Number(params['sections']);
        }

        if (params['lang']) {
          const findLang = this.appSettings.langs.find((lang) => lang.value === params['lang']);
          if (findLang) {
            this.appSettings.selectedLang = findLang.value;
            this.appSettings.genders = [
              {
                label: this.appSettings.translate[this.appSettings.selectedLang]['undefGender'],
                value: 0,
              },
              {
                label: this.appSettings.translate[this.appSettings.selectedLang]['manGender'],
                value: 1,
              },
              {
                label: this.appSettings.translate[this.appSettings.selectedLang]['womanGender'],
                value: 2,
              },
            ];
            this.appSettings.selectedLang = findLang.value;
            // this.progressService.getScoresEqualInitiator.next();
          }
        }

        if (params['date']) {
          this.date = new Date(params['date']);
          if (this.date) {
            if (params['uid']) {
              this.preSelectRace = params['uid'];
            }

            if (params['class']) {
              this.preSelectClass = params['class'];
            }
          }
        }
      })
    );

    this.date = new Date();
    this.selectedRace = undefined;
    this.selectedRaceTmp = undefined;

    this.subscriptions.push(
      this.commonService.closeRegistrationDialog.subscribe(() => {
        this.changeSelectedRace({
          selectedRace: this.selectedRace,
          raceClasses: this.raceClasses,
          selectedClassUid: this.selectedClass ? this.selectedClass.clUid : undefined,
        });
      })
    );

    this.subscriptions.push(
      this.imageService.fullResumeEvent.subscribe((urlImage) => {
        this.fullImageUrl = urlImage;
      })
    );
  }

  ngOnInit() {
    if (!this.preSelectRace) return;
    this.progressService
      .getRace(this.preSelectRace)
      .then((race) => {
        this.selectedRaceTmp = race;
        if (this.selectedRaceTmp) this.initRace(this.selectedRaceTmp);
      });
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    this.getInfoCompInitiator.complete();
  }

  //Закрывает PDF с полного режима отображения
  hideFullPdf(): void {
    this.fullPdfUrl = undefined;
  }

  //Закрывает изображение с полного режима отображения
  hideFullImage(): void {
    this.imageService.fullResumeEvent.emit(undefined);
  }

  // Дополняет данные переданной гонки списком классов и приложений
  initRace(selectedRace: Race) {
    this.progressService
      .getRaceClasses(selectedRace)
      .then((raceClasses) => {
        if (!raceClasses) return;
        this.selectedRace = selectedRace;
        this.raceClasses = raceClasses;
        this.setTitle();
        this.progressService.getListImages(this.selectedRace);
        this.changeSelectedRace({
          selectedRace: this.selectedRaceTmp,
          raceClasses: raceClasses,
          selectedClassUid: this.selectedClass ? this.selectedClass.clUid : undefined,
        });
        this.cdr.detectChanges();
      });
  }

  // Выставляет название страницы в браузере равным названию гонки
  setTitle() {
    const pageName = this.appSettings.translate[this.appSettings.selectedLang][this.selectTable];
    const title = `${this.selectedRace?.name}, ${this.datePipe.transform(this.selectedRace?.date, 'dd.MM.yyyy')} - ${pageName}`;
    this.titleService.setTitle(title);
  }

  // Загрузка данных участников выбранного класса (классов)
  async changeSelectedRace(raceRefreshObject: RaceRefreshObject) {
    const selectedClass = this.raceClasses.find((item) => item.clUid === raceRefreshObject.selectedClassUid);
    if (
      this.raceClasses.length &&
      (!this.selectedClass || (this.selectedClass && raceRefreshObject.selectedClassUid !== this.selectedClass.clUid))
    ) {
      if (raceRefreshObject.selectedClassUid) {
        this.selectedClass = selectedClass;
      } else {
        if (this.selectTable === this.appSettings.TABLE_TYPE.DOCUMENTS) {
          const allClass: RaceClass = new RaceClass({
            name: this.appSettings.translate[this.appSettings.selectedLang]['header_all'],
            clUid: 'ALL',
          });
          this.raceClasses.unshift(allClass);
        }
        this.selectedClass = this.raceClasses[0];
      }
    }

    if (this.selectedClass) console.log(`%cОбновлены данные класса: ${this.selectedClass.clUid}`, 'color: #bada55');

    const raceClass = raceRefreshObject.raceClasses.find((rClass) => rClass.clUid == raceRefreshObject.selectedClassUid);
    if (raceRefreshObject.selectedClassUid && raceClass && !selectedClass) {
      raceRefreshObject.raceClasses.unshift(raceClass);
    }

    if (this.selectedClass && raceRefreshObject.selectedRace) {
      if (this.selectedClass.clUid == 'ALL') {
        for (const raceClass of raceRefreshObject.raceClasses) {
          if (raceClass.clUid == 'ALL') continue;
          await this.progressService.getParticipants(
            raceRefreshObject.selectedRace,
            raceClass,
            !(this.selectedClass && raceRefreshObject.selectedClassUid === this.selectedClass.clUid),
            raceRefreshObject.selectedFilter
          );
        }
      } else {
        await this.progressService.getParticipants(
          raceRefreshObject.selectedRace,
          this.selectedClass,
          !(this.selectedClass && raceRefreshObject.selectedClassUid === this.selectedClass.clUid),
          raceRefreshObject.selectedFilter
        );
      }
    }

    this.updateData(this.selectTable);
    this.cdr.detectChanges();
  }

  // Запуск обновления таблицы участников
  updateData(value: string) {
    // if(!this.selectTable && this.selectTable === this.TABLE_TYPE.PROGRESS) {
    this.selectTable = value;
    this.progressService.refreshTableData.emit(this.selectedClass?.clUid);
    // }
  }

  // Переход в новую версию результатов
  goToNewVersion() {
    // this.selectTable = this.appSettings.TABLE_TYPE.PROGRESSV2;
    const newHref = window.location.href.replace('section=results-table', 'section=results');
    window.location.href = newHref;

    // console.log('goToNewVersion');

    // const href = `${this.appSettings.settings.urlGTM}/progress/list`;
    // this.router.navigate([href], {
    //   relativeTo: this.route,
    //   queryParams: {
    //     date: this.datePipe.transform(this.selectedRace?.date, 'MM/dd/yyyy'),
    //     section: 'results',
    //     uid: this.selectedRace?.rUid,
    //     lang: this.appSettings.selectedLang
    //   }
    // });
  }

  // Переход в старую версию результатов
  goToOldVersion() {
    // this.selectTable = this.appSettings.TABLE_TYPE.PROGRESS;
    const newHref = window.location.href.replace('section=results', 'section=results-table');
    window.location.href = newHref;

    // console.log('goToOldVersion');

    // const href = `${this.appSettings.settings.urlGTM}/progress/list`;
    // this.router.navigate([href], {
    //   relativeTo: this.route,
    //   queryParams: {
    //     date: this.datePipe.transform(this.selectedRace?.date, 'MM/dd/yyyy'),
    //     section: 'results-table',
    //     uid: this.selectedRace?.rUid,
    //     lang: this.appSettings.selectedLang
    //   }
    // });
  }

  //
  //
  //
  // -----------  ЧТО ТО ТАКОЕ ПРО КОПИРОВАНИЕ УИДА ГОНКИ И КЛАССА, ОТКРЫТИЕ ОКНА КАРТЫ -  ВРОДЕ НИГДЕ НЕ ИСПОЛЬЗУЕТСЯ -----------------------------------------------------

  isOS() {
    //can use a better detection logic here
    return navigator.userAgent.match(/ipad|iphone/i);
  }

  copy(text: string, summary: string) {
    let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = text;
    document.body.appendChild(selBox);
    selBox.focus();
    if (this.isOS()) {
      let range = document.createRange();
      range.selectNodeContents(selBox);
      let selection = window.getSelection();
      if (selection) {
        selection.removeAllRanges();
        selection.addRange(range);
      }
      selBox.setSelectionRange(0, 999999);
    } else {
      selBox.select();
    }
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.messageService.clear();
    this.messageService.add({ severity: 'success', summary });
  }

  clipboardRaceUid() {
    if (this.selectedRace) {
      this.copy(this.selectedRace.rUid, this.appSettings.translate[this.appSettings.selectedLang]['uidIsCopying']);
    }
  }

  // Подписываемся на получение инфо участника
  private subscribeToGet() {
    const sub = this.getInfoCompInitiator
      .pipe(
        switchMap((cUid) => {
          return this.progressService.getCompetitorInfo(cUid);
        })
      )
      .subscribe((info: CompetitorInfo) => {
        this.dataCompetitorInfoModal = info;
        this.showCompetitorInfoModal = true;
      });
    this.subscriptionGet = sub;
    this.subscriptions.push(sub);
  }

  showModal(cUid: string) {
    this.getInfoCompInitiator.next(cUid);
  }

  showCompetitorRaceDataModal(info: string) {
    this.dataCompetitorRaceInfoModal = info;
    this.showCompetitorRaceInfoModal = true;
  }

  clipboardLinkClass() {
    this.copy(
      `${this.appSettings.settings.urlGTM}/progress/list/?date=${this.date.getMonth() + 1
      }/${this.date.getDate()}/${this.date.getFullYear()}&uid=${this.selectedRace?.rUid}&class=${this.selectedClass?.clUid}&lang=${this.appSettings.selectedLang
      }`,
      this.appSettings.translate[this.appSettings.selectedLang]['linkIsCopying']
    );
  }

  openMap() {
    window.open(
      `/public/race_map/?raceUID=${this.selectedRace?.rUid}&classUID=${this.selectedClass?.clUid}&lang=${this.appSettings.selectedLang}`,
      '_blank'
    );
  }
}
